import { Button, Dialog, Inline, Text } from '@etg/wings';
import { Illustration } from '@eti/components';
import { useDirection, useSiteContext } from '@eti/providers';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ValidationModal = ({
  isOpen,
  labels,
  onContinueWithout,
  onKeepEditing
}) => {
  const {
    isRTL
  } = useDirection();
  const {
    brand
  } = useSiteContext();
  return /*#__PURE__*/_jsx(Dialog, {
    "data-testid": "pick-and-choose-validation-modal",
    footer: /*#__PURE__*/_jsxs(Inline, {
      align: "end",
      collapseBelow: "560px",
      spacing: 8,
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: onContinueWithout,
        children: labels.validationContinueWithout
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onKeepEditing,
        variant: "primary",
        children: labels.validationKeepEditing
      })]
    }),
    illustration: /*#__PURE__*/_jsx(Illustration, {
      "aria-hidden": "true",
      brand: brand.code,
      "data-testid": "pick-and-choose-validation-modal-illustration",
      id: "pick-and-choose-warning",
      mirrored: isRTL
    }),
    isOpen: isOpen,
    title: labels.validationTitle,
    children: /*#__PURE__*/_jsx(Text, {
      variant: "14",
      children: labels.validationBody
    })
  });
};
export default ValidationModal;
//# sourceMappingURL=ValidationModal.js.map